import { render, staticRenderFns } from "./gridHiddenMsg.vue?vue&type=template&id=10a627fd&lang=pug&"
import script from "./gridHiddenMsg.vue?vue&type=script&lang=js&"
export * from "./gridHiddenMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports